var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignaletique(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke-linecap:round;}.cls-1,.cls-3{stroke:#e6007e;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#e6007e;}.cls-3{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "signal\\xE9tique_personnalis\\xE9e",
    "data-name": "signal\\xE9tique personnalis\\xE9e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.29,24.31V19.38s-13.1,3.13-17.46,3.13-17-3.13-17-3.13v4.93s12.73,3.13,17,3.13S50.29,24.31,50.29,24.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.38,39.5h-.09v-.21l-16-12H31.81L16.75,39.69a3.65,3.65,0,0,0-1.15-.19,3.76,3.76,0,1,0,3.67,4.56L33.19,32.4,46.65,42.75a4.36,4.36,0,0,0,0,.51,3.76,3.76,0,1,0,3.76-3.76Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignaletique);
export default __webpack_public_path__ + "static/media/signaletique.d763a0bdae1a1c9bc91f88ce7e998156.svg";
export { ForwardRef as ReactComponent };